import BillyApi from '../../api/BillyApi';

const state = {
  cardNumberMask: null,
};

const actions = {
  async fetch({ commit }) {
    const creditCardDetails = await BillyApi.getCreditCardDetails();
    if (creditCardDetails) {
      commit('setCardNumberMask', creditCardDetails.cardNumberMask);
    }
  },
};

// mutations
const mutations = {
  setCardNumberMask(state, cardNumberMask) {
    state.cardNumberMask = cardNumberMask;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
